import { PipesModule, SaI18nPipe, XsI18nPipe } from '@nx-fe/pipes';
import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ErrorHandlerService, XSi18nService } from '@nx-fe/services';
import { InsMaterialModule } from '@nx-fe/ins-material';
import { AgGridModule } from 'ag-grid-angular';
import { MatDialogModule } from '@angular/material/dialog';
import { SearchAndPickV2Component } from './components/search-and-pick/search-and-pick.component';
import { MatOptionDisplayWrapperPipe } from './pipes/sa-matoptiondisplaywrapper.pipe';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { DeviceModule } from 'sspapp/modules/devices/devices.module';

@NgModule({
  declarations: [SearchAndPickV2Component, MatOptionDisplayWrapperPipe, SnackbarComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatTooltipModule,
    MatInputModule,
    DeviceModule,
    PipesModule,
    InsMaterialModule,
    AgGridModule,
  ],
  exports: [SearchAndPickV2Component, SnackbarComponent],
  providers: [XsI18nPipe, MatOptionDisplayWrapperPipe, SaI18nPipe, XSi18nService, DecimalPipe, ErrorHandlerService],
})
export class SharedComponentsModule {}
